<template>
  <main class="container-fluid p-0 px-xl-4">
    <div class="home">
      <!-- <div class="container-xxl"> -->
        <div class="slider-container">
          <main-slider></main-slider>
        </div>
      <!-- </div> -->
      <!-- <div class="container"> -->
        <premieres :class="{ 'no-gutters': isMobile() }" :premieres="premieres" />
      <!-- </div> -->
    </div>
    <exclusive-content :exclusives="exclusives"></exclusive-content>
    <body-promo-uno></body-promo-uno>
    <featured-actors :content="actor" />
    <available-on />
    <testimonials />
    <our-products-mobile v-if="isMobile()" />
    <our-products v-else />

    <be-part-of />
  </main>
</template>

<script>
import MainSlider from "../../components/landing/mainSlider.vue";
import Premieres from "../../components/landing/premieres.vue";
import ExclusiveContent from "../../components/landing/exclusiveContent.vue";
import BodyPromoUno from "../../components/landing/BodyPromoUno.vue";
import FeaturedActors from "../../components/landing/FeaturedActors.vue";
import Testimonials from "../../components/landing/Testimonials.vue";
import OurProducts from "../../components/landing/OurProducts.vue";
import BePartOf from "../../components/landing/BePartOf.vue";

import { OrizonApiClient } from "@/services/OrizonApiClient";
import AvailableOn from "../../components/landing/AvailableOn.vue";
import OurProductsMobile from "@/components/landing/OurProductsMobile.vue";
import { i18n } from "@/functional/languages";
import MetaService from "@/services/MetaService";
import { mapState } from "pinia";
import { ActorStore } from "@/stores/actorStore";
import { SessionStore } from "@/stores/sessionStore";
const apiClient = new OrizonApiClient();

// noinspection JSCheckFunctionSignatures
export default {
  name: "HomeView",
  metaInfo: () => {
    return {
      title: i18n.global.t("home.meta.title"),
      htmlAttrs: { lang: i18n.global.locale },
      meta: [
        MetaService.robotIndex(),
        MetaService.description(i18n.global.t("home.meta.description")),
      ],
    };
  },
  components: {
    MainSlider,
    Premieres,
    ExclusiveContent,
    BodyPromoUno,
    FeaturedActors,
    Testimonials,
    OurProducts,
    BePartOf,
    AvailableOn,
    OurProductsMobile,
  },
  data() {
    return {
      premieres: [],
      exclusives: [],
      actor: null,
    };
  },
  beforeUnmount() {
    console.info("unmounting home view");
    this.$bus.off("langChanged");
  },
  mounted() {
    this.fetchLanding();
    this.setFreemiumWorkflow(false);
    this.$bus.on("langChanged", () => {
      try {
        this.fetchLanding();
      } catch (e) {
        console.info("fetch landing", e.title);
      }
    });
    this.$meta.canonicalUrls(
      this.$t("routes.home", "es"),
      this.$t("routes.home", "en"),
      "/"
    );
  },
  methods: {
    fetchLanding: function () {
      apiClient.get("/landing?limit=12").then((response) => {
        if (
          response !== null &&
          response.data !== null &&
          !response.data.error
        ) {
          this.premieres = response.data.top;
          this.exclusives = response.data.mid;
          this.actor = response.data.actor;
          this.setFeaturedActor(response.data.actor);
        }
      });
    },
  },
  computed: {
    ...mapState(ActorStore, ["setFeaturedActor"]),
    ...mapState(SessionStore, ["setFreemiumWorkflow"]),
  },
};
</script>
<style lang="scss" scoped>
.home{
  .slider-container{
    margin: 0px;
  }
}


.home{
  @media (min-width: 600px) {
    .slider-container{
      margin: 1em 2em;
    }
  }
  
  @media (min-width: 1000px) {
    .slider-container{
      margin: 1em 4em;
    }
  }
}
</style>